module.exports = __webpack_public_path__ + "static/media/eggmasala.e28db3b9.jpg";